import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { Asset, RenameAsset, Point } from '../../context-discovery-services/models';
import { AssetStatus } from '../../context-discovery-services/constants/asset-status.const';
import { ConfigurePoint } from '../../context-discovery-services/models/configure-point.model';


@Component({
  selector: 'adminapp-assets-grid',
  templateUrl: './assets-grid.component.html',
  styleUrls: ['./assets-grid.component.scss']
})
export class AssetsGridComponent implements AfterViewInit, OnInit {

  assetsGrid: any;
  assetsGridSelectAll: any;
  assets: Array<Asset>;
  @Input()
  isLoading = false;

  constructor() { }

  @Input()
  set assetsList(listOfAssets: Array<Asset>) {
    if (!this.assetsGrid || !listOfAssets) {
      return;
    }
    this.assetsGrid.items = listOfAssets.map(asset => {
      asset.status = asset.confirmed ? AssetStatus.CONFIRMED : AssetStatus.UNCONFIRMED;
      asset.pointsWithRolesCount = _.filter(asset.points, point => point.roleAssigned).length;
      if (asset.points) {
        asset.points.map(point => {
          point['assignedRoleLabel'] = (point.roles && point.roles.length > 0 && point.roleAssigned) ? point.roles[0].label : '';
          point['belongsToAsset'] = asset.id;
        });
      }

      return asset;
    });
    setTimeout(function () {
      if (this.assetsGrid && this.assetsGrid.refreshData) {
        this.assetsGrid.refreshData();
      }
    }.bind(this), 10);
    this.assets = this.assetsGrid.items;
  }

  @Output()
  assetRenamedEmitter: EventEmitter<RenameAsset> = new EventEmitter<RenameAsset>();

  @Output()
  pointConfiguredEmitter: EventEmitter<ConfigurePoint> = new EventEmitter<ConfigurePoint>();

  @Output()
  invalidPointConfigureEmitter: EventEmitter<any> = new EventEmitter<any>();


  ngAfterViewInit(): void {
    this.assetsGrid = document.getElementById('assets-grid');
    if (this.assetsGrid) {
      this.assetsGridSelectAll = this.assetsGrid._selectAllCheckbox;
      this.assetsGrid.itemChildrenField = 'points';
      this.assetsGrid.columns = this.getColumnsForAssetsGrid();
      window['editIconClicked'] = this.onEditIconClicked.bind(this);
    }
  }

  getColumnsForAssetsGrid() {
    return [
      { id: 'SelectAll', width: '50px' },
      { id: 'label', label: 'Label', isSortable: true, isResizable: true, width: '700px' },
      { id: 'comment', label: 'Description', isSortable: true, isResizable: true },
      { id: 'unitLabel', label: 'Unit Label', isSortable: true, isResizable: true },
      { id: 'assignedRoleLabel', label: 'Role', isSortable: true, isResizable: true },
      { id: 'enumsAssetsGrid', label: 'Enums', isResizable: true },
      { id: 'edit', label: ' ', isResizable: false }
    ];
  }

  ngOnInit(): void {
  }

  getSelectedItems() {
    return this.assetsGrid ? this.assetsGrid.selectedItems : [];
  }

  unselectAll() {
    this.assetsGrid.selectItems(this.assetsGrid.items, false);
  }

  getEnumsFromPoint(point: Point) {
    const allConceptLabels = [];
    if (point.bindings) {
      point.bindings.forEach(
        function (propBinding) {
          const conceptMapKeys = Object.keys(propBinding.conceptMap);
          if (conceptMapKeys) {
            conceptMapKeys.forEach(
              function (conceptMapKey) {
                allConceptLabels.push(propBinding.conceptMap[conceptMapKey]);
              }
            );
          }
        }
      );
    }
    return allConceptLabels.filter((it, i, ar) => ar.indexOf(it) === i).join(', ');
  }

  onEditIconClicked(e) {
    const divId = e.id.split('&&');
    if (divId.length === 2) {
      const iri = divId[0];
      const label = divId[1];
      this.assetRenamedEventHandler(iri, label);
    } else {
      const assetIri = divId[0];
      const pointIri = divId[1];
      const pointName = divId[2];
      this.pointConfiguredEventHandler(assetIri, pointIri, pointName);
    }
  }

  assetRenamedEventHandler(assetIri: string, assetName: string) {
    this.assetRenamedEmitter.emit({
      assetIri: assetIri,
      assetName: assetName
    });
  }

  pointConfiguredEventHandler(assetIri: string, pointIri: string, pointName: string) {

    const asset = this.assets.filter(asset => asset.id === assetIri);

    if (asset && asset[0].status === AssetStatus.UNCONFIRMED) {
      this.invalidPointConfigureEmitter.emit({});
    } else {
      this.pointConfiguredEmitter.emit({
        pointIri: pointIri,
        pointName: pointName
      });
    }
  }
}
